var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LMModalService } from "../../services/lm-modal.service";
import { UserService } from "../../services/user.service";
import { EduComponent } from "../../utils/eduComponent";
import Utils from "../../utils/utils";
import { JoinRosterModalComponent } from "../modals/join-roster-modal/join-roster-modal.component";
var StudentAppComponent = /** @class */ (function (_super) {
    __extends(StudentAppComponent, _super);
    function StudentAppComponent(userService, lmModalService, modalService, notificationService, route) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.lmModalService = lmModalService;
        _this.modalService = modalService;
        _this.notificationService = notificationService;
        _this.route = route;
        _this.activeTab = "none";
        _this.notStartedCount = null;
        _this.assignments = [];
        _this.enterCode = "";
        _this.loginFavoriteText = "Log In to save links in your Favorites. Search or browse the site without logging in.";
        _this.register();
        return _this;
    }
    StudentAppComponent.prototype.register = function () {
        var _this = this;
        if (!this.userService.hasStudentExperience()) {
            return;
        }
        this.userService.loadAssignments();
        this.addSub(this.userService.assignments.subscribe(function (assignments) {
            _this.assignments = assignments;
            _this.notStartedCount = assignments.filter(function (obj) {
                return obj.status === "not_started";
            }).length;
        }));
        this.addSub(this.userService.runOnceForQueryParam(this.route, "code", function (code) {
            _this.handleRosterJoinLink(code);
        }));
        this.checkJoinRosterURL();
    };
    StudentAppComponent.prototype.checkJoinRosterURL = function () {
        var path = window.location.pathname;
        if (!path || !path.startsWith("/student/join/")) {
            return;
        }
        var slugs = path.split("/");
        if (slugs.length < 4) {
            return;
        }
        this.handleRosterJoinLink(slugs[3]);
    };
    StudentAppComponent.prototype.handleRosterJoinLink = function (code) {
        /*
        This handles legacy cases:
        1. Assignment preview (/tools/lessonbuilder/preview/?code=banana9580) We shouldn't do anything here. The
        teacher will see the assignment taking section in the preview mode.
        -> This case will be ignored. The old site iframe will show the preview and no student app section will be open.
        2. Join class link (student/?code=5664bear) The classes tab should open and the join roster modal should open.
        -> Open the classes section and the join classes modal after.

        TODO: Once the preview assignment is in the new site, this should be refactored
         */
        if (!code) {
            return;
        }
        if (Utils.isAssignmentCode(code)) {
            return;
        }
        if (this.userService.isLoggedIn()) {
            this.activeTab = "classes";
            this.joinClass(code);
        }
        else {
            this.notificationService.warn("", "To enter a class you must be logged in.", Utils.alertConfiguration);
            this.lmModalService.openLoginModal();
        }
    };
    StudentAppComponent.prototype.toggleTray = function ($event, caller) {
        $event.preventDefault();
        if (!this.userService.isLoggedIn()) {
            this.lmModalService.openLoginModal();
            return;
        }
        if (this.userService.isLoggedIn()) {
            if (caller === this.activeTab) {
                this.activeTab = "none";
            }
            else {
                this.activeTab = caller;
            }
        }
    };
    StudentAppComponent.prototype.closeTray = function () {
        this.activeTab = "none";
    };
    StudentAppComponent.prototype.onFavoriteClick = function ($event) {
        if (!this.userService.isLoggedIn()) {
            this.lmModalService.openLoginModal();
            $event.preventDefault();
            return;
        }
    };
    StudentAppComponent.prototype.enterGenericCode = function (event) {
        var _this = this;
        event.preventDefault();
        if (this.enterCode) {
            this.userService.enterStudentCode(this.enterCode).subscribe(function (data) {
                if (data.url && data.code) {
                    // roster code
                    // window.location.href = data.url;
                    _this.activeTab = "classes";
                    _this.joinClass(data.code);
                }
                else if (data.url && data.url.length > 0) {
                    // assignment code
                    window.location.href = data.url + "?q=code_entered";
                }
                else if (data.error) {
                    _this.notificationService.error("", data.error, Utils.alertConfiguration);
                }
            }, function (error) {
                _this.notificationService.error("Uh oh!", "Invalid code entered.", Utils.alertConfiguration);
            });
        }
        else {
            this.notificationService.error("", "Please enter a code", Utils.alertConfiguration);
        }
    };
    StudentAppComponent.prototype.joinClass = function (code) {
        var _this = this;
        this.userService.fetchClassDetails(code).subscribe(function (classDetails) {
            var modal = _this.modalService.open(JoinRosterModalComponent);
            modal.componentInstance.rostercode = code;
            modal.componentInstance.classInvitation =
                classDetails.teacher_name + "'s - " + classDetails.name;
            modal.componentInstance.classId = classDetails.id;
        }, function (error) {
            _this.notificationService.error("Uh oh!", "Invalid class code.", Utils.alertConfiguration);
        });
    };
    return StudentAppComponent;
}(EduComponent));
export { StudentAppComponent };
